var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('script',{style:({ width: _vm.width + 'px', fontSize: _vm.height + 'px' }),attrs:{"id":_vm.id,"type":"text/plain","xml:space":"preserve"}})])}
var staticRenderFns = []
export { render, staticRenderFns }